import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Building, Hammer } from 'lucide-react';

const ServiceCards = () => {
    const services = [

        {
            id: 1,
            title: 'Residential',
            description: 'Custom homes designed to fit your lifestyle, blending comfort with modern aesthetics.',
            icon: <Home size={40} />,
            image: '/assets/photos/elevations/P_10.jpg'
        },
        {
            id: 2,
            title: 'Commercial',
            description: 'State-of-the-art office spaces and commercial complexes built for business success.',
            icon: <Building size={40} />,
            image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=800'
        },
        {
            id: 3,
            title: 'Renovation & Redevelopment',
            description: 'Transforming existing structures into modern masterpieces with expert craftsmanship.',
            icon: <Hammer size={40} />,
            image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80&w=800'
        }
    ];

    return (
        <section className="py-20 bg-gray-50" id="services">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Expertise</h2>
                    <div className="w-20 h-1 bg-primary mx-auto"></div>
                    <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
                        Delivering excellence across all sectors of construction and development.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {services.map((service) => (
                        <div
                            key={service.id}
                            className="bg-white rounded-xl shadow-lg overflow-hidden group hover:-translate-y-2 transition-transform duration-300"
                        >
                            <div className="h-48 overflow-hidden">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                                />
                            </div>
                            <div className="p-8 relative">
                                <div className="absolute -top-10 right-8 bg-primary text-white p-4 rounded-lg shadow-md">
                                    {service.icon}
                                </div>
                                <h3 className="text-xl font-bold text-gray-800 mb-3 mt-2">{service.title}</h3>
                                <p className="text-gray-600 leading-relaxed mb-6">
                                    {service.description}
                                </p>
                                <Link to="/services" className="text-primary font-semibold hover:text-orange-700 inline-flex items-center">
                                    Learn More
                                    <span className="ml-1 group-hover:ml-2 transition-all">&rarr;</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceCards;
